import React from "react";
import { connect } from "react-redux";
import { Form, Control } from "react-redux-form";
import * as appActions from "../../actions/appActions";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import "../../styles/loginForm.scss";
import { Link } from "react-router";
import { Input, Button, Image } from "semantic-ui-react";
import Flagship from "../../core/flagship";

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.setRandomMessage = this.setRandomMessage.bind(this);
    this.state = {
      randomText: "Loading..."
    };
  }

  handleSubmit(login) {
    this.props.actions.login(login);
  }

  componentWillMount() {
    this.setRandomMessage();
  }

  componentDidMount() {
    document.title = "Flagship / Login";
  }

  setRandomMessage() {
    let messageOptions = [
      "Abandon ship!",
      "This ship has sailed!",
      "Not for sail.",
      "All hands off deck.",
      "Buoy, It’s Been a Good Run",
      "Arrr-chived!",
      "Thar Be No New Orders Here!"
    ];

    let randomNumber = Math.floor(Math.random() * messageOptions.length);
    let newText = messageOptions[randomNumber];

    if (newText === this.state.randomText) {
      this.setRandomMessage();
    } else {
      this.setState({
        randomText: newText
      });
    }
  }
  render() {
    if (this.props.isLoggedIn === true) {
      browserHistory.push("/");
    }
    let login = this.props;

    return (
      <div id="login-form" className="fade-in">
        <div
          id="login-form-inner"
          className={login.login.failed ? "animated headShake" : ""}
        >
          <Image src="/assets/logo-white@2x.png" alt="Welcome to Flagship" />
          <h3
            className="white-text login-subheading"
            onClick={this.setRandomMessage.bind(this)}
          >
            {this.state.randomText}
          </h3>
          <p className="login-message">
            {login.login.message ? login.login.message : ""}
          </p>

          <Form
            autoComplete="off"
            model="login"
            onSubmit={login => this.handleSubmit(login)}
          >
            <label htmlFor="login.username">Username:</label>
            <Control.text
              model="login.username"
              component={Input}
              autoComplete="off"
              fluid
              transparent
              size="big"
              className="single-field"
              placeholder="Username"
            />

            <label htmlFor="login.password">Password:</label>
            <Control.text
              model="login.password"
              component={Input}
              fluid
              transparent
              size="big"
              className="single-field"
              type="password"
              placeholder="Password"
            />

            <Button size="big" primary fluid type="submit">
              Log In
            </Button>
            <br />
            <Link className="white-text" to="/login/reset">
              Forgot Password
            </Link>
          </Form>

          <div className="fs-version">Version {Flagship.config.version}</div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(appActions, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    login: state.login
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/views/Login.js